import './App.css';
import { useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import WhatsappButton from './components/WhatsappButton';
import TagManager from 'react-gtm-module';
import InspiniaRouter from './components/InspiniaRouter';
import { AppRoutes } from './routes';

function App() {
  const location = useLocation();
  TagManager.dataLayer({
    dataLayer: {
      event: 'Pageview',
      pagePath: location.pathname,
      pageTitle: document.title,
    },
  });

  return (
    <>
      <InspiniaRouter routes={AppRoutes} />
      <WhatsappButton />
    </>
  );
}

export default App;
